<footer>
	<hr />
	<p #decryptedtext></p>
</footer>
